import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ExternalUserFindInterface } from '@zaoblako/shared/modules/security/dtos/external-user/external-user-find.dto';
import { UserFindInterface } from '@zaoblako/shared/modules/security/dtos/user/user-find.dto';
import { UserAvatarComponent } from '@zaoblako/web/shared/components/user-avatar/user-avatar.component';

@Component({
  selector: 'crm-user-card-preview',
  standalone: true,
  imports: [CommonModule, UserAvatarComponent],
  templateUrl: './user-card-preview.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserCardPreviewComponent {
  @Input() public user: UserFindInterface | ExternalUserFindInterface;
}
